import "@/styles/print/print.css";

export default {
  install(Vue) {
    Vue.prototype.$printBet = function() {
      var bet = document.getElementById("bet-card").innerHTML;
      print(bet);
    };

    Vue.prototype.$printReport = function() {
      var report = document.getElementById("print-report").innerHTML;
      print(report);
    };

    Vue.prototype.$printReportExtract = function() {
      var report = document.getElementById("print-report-extract").innerHTML;
      print(report);
    };

    Vue.prototype.$printCard = function() {
      var report = document.getElementById("print-card").innerHTML;
      print(report);
    };

    // Global
    Vue.prototype.$print = function(id) {
      var report = document.getElementById(id).innerHTML;
      print(report);
    };

    Vue.prototype.$saveBetAsPdf = (bet_id) => {
      const user_data = localStorage.getItem("user_data");
      const { db_name } = JSON.parse(user_data);
      const bet_data = document.getElementById("bet-card").innerHTML;
      downloadPdf(db_name, bet_id, bet_data);
    };
  },
};

// Get 'Fonts' and 'Icons':
let stylesFonts = "";
for (const node of [...document.querySelectorAll('link[rel="stylesheet"]')]) {
  stylesFonts += node.outerHTML;
}

// Get 'text/css' HTML:
let stylesHtml = "";
for (const node of [...document.querySelectorAll('style[type="text/css"]')]) {
  stylesHtml += node.outerHTML;
}

// Function Print:
const print = (dataPrint) => {
  const user_data = localStorage.getItem("user_data");
  const { db_name } = JSON.parse(user_data);

  // <body onafterprint="self.close()">
  const win = window.open("about:blank");
  win.document.write(
    `<!DOCTYPE html>
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">      
        <title>Imprimir</title>                
        ${stylesFonts}                     
        ${stylesHtml}          
      </head>
      <body id="view-print" onafterprint="self.close()">
        <div class="v-application v-application--is-ltr" id="app">            
          <div class="v-application--wrap">
            <div class="">
              <div class="text-center">
                <img                  
                  style="max-width:45px;"
                  src="https://sga-assets.s3-sa-east-1.amazonaws.com/domains/${db_name}/img/logo.png"
                />
              </div>
              ${dataPrint}
            </div>
          </div>
        </div>
      </body>
    </html>`
  );
  win.document.close();
  win.focus();
  setTimeout(function() {
    win.print();
  }, 300); // fix. setTimeout resolve error build production.
};

const downloadPdf = (domain, bet_id, data) => {
  const win = window.open("about:blank");
  win.document.write(
    `<!DOCTYPE html>
      <html>
        <head>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">      
          <title>Imprimir</title>                
          ${stylesFonts}                     
          ${stylesHtml}
        </head>
        <body id="view-print" class="pdf">
          <div class="v-application v-application--is-ltr" id="app">            
            <div class="v-application--wrap">
              <div class="mx-auto" style="width:"15em">
                <div class="text-center">
                  <img
                    id="operatorLogoPdf"
                    style="max-width:100px; margin-top:10px"                        
                    src="https://sga-assets.s3-sa-east-1.amazonaws.com/domains/${domain}/img/logo.png"
                  />
                </div>
                <div id="capture">
                  ${data}
                </div>
              </div>
            </div>
          </div>
        </body>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
        <script type="text/javascript">
              const element = document.getElementById('view-print');
              html2pdf().set({
                  html2canvas: { scale: 2 },
              }).from(element).toCanvas().toImg().toPdf().save("Aposta ${bet_id}");
        </script>
      </html>`
  );
};
